<template>
  <div
    class="popup"
    :class="{
      'popup--hidden': accept,
      'popup--visible': mounted && !accept
    }"
  >
    <p class="popup__text">
      This website uses cookies to ensure you get the best experience on our website
      <a target="_blank" rel="noopener noreferrer" href="/cookies">Learn more</a>
    </p>
    <button @click="acceptCookie()" class="popup__btn mt-3" role="button">
      Accept cookies <i class="ms-1 fas fa-cookie-bite"></i>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accept: false,
      mounted: false, // Track if component mounted
    };
  },
  methods: {
    acceptCookie() {
      this.accept = true;
      localStorage.setItem("cookie", true);
    },
  },
  mounted() {
    if (localStorage.getItem("cookie")) {
      this.accept = true;
    }
    setTimeout(() => {
      this.mounted = true;
    }, 500); // half a second after page load
  },
};
</script>

<style lang="scss">
@import "../styles/_variables";

.popup {
  width: 95%;
  position: fixed;
  bottom: 2.5%;
  left: 2.5%;
  background: white;
  padding: 10px 15px 15px;
  border-radius: 5px;
  backdrop-filter: blur(20px);
  color: #222;
  font-size: 13px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  z-index: 2147483647;
  max-width: 500px;
  border: 1px solid;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  pointer-events: none;

  a {
    color: #000000;
  }

  & > p {
    font-size: 1em;
    color: blue;
    margin: 0;
  }

  button {
    border: 0;
    background: black;
    color: #fff;
    border-radius: 5px;
    font-weight: 800;
    padding: 5px 10px;
    transition: all 0.3s;

    &:hover {
      background-color: #000000;
    }
  }
}

// When visible
.popup--visible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

// When accepted
.popup--hidden {
  opacity: 0;
  pointer-events: none;
  transform: translateY(20px);
}

// Accessibility - this will disable animations for users with reduced motion
@media (prefers-reduced-motion: reduce) {
  .popup {
    transition: none;
    transform: none;
  }
}
</style>
